// GENERATED from ez-tree preset "Bush 3" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const Bush3_KIND_ID = "ezTree_Bush3";

export const Bush3Kind = new SceneryKindDef({
	id: "ezTree_Bush3",
	name: "Bush 3",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchAngle1": 66.52173913043478,
		"branchAngle2": 52.82608695652174,
		"branchAngle3": 0,
		"branchChildren0": 13,
		"branchChildren1": 4,
		"branchChildren2": 4,
		"branchGnarliness0": 0.05434782608695654,
		"branchGnarliness1": 0.06521739130434778,
		"branchGnarliness2": 0.05,
		"branchGnarliness3": 0.09,
		"branchLength0": 10.958695652173914,
		"branchLength1": 21.81739130434783,
		"branchLength2": 13.130434782608695,
		"branchLength3": 5.529347826086957,
		"branchRadius0": 0.5793478260869566,
		"branchRadius1": 0.9521739130434783,
		"branchRadius2": 0.6858695652173914,
		"branchRadius3": 0.7391304347826086,
		"branchSections0": 4,
		"branchSections1": 3,
		"branchSections2": 3,
		"branchSections3": 10,
		"branchSegments0": 3,
		"branchSegments1": 3,
		"branchSegments2": 3,
		"branchStart1": 0.14130434782608695,
		"branchStart2": 0.29347826086956524,
		"branchStart3": 0,
		"branchTwist0": 0.3,
		"branchTwist1": -0.03260869565217389,
		"treeType": "evergreen",
		"leafCount": 3,
		"leafSize": 3.0434782608695654,
		"leafSizeVariance": 0.45652173913043476,
		"leafAngle": 54,
		"leafStart": 0.15217391304347827,
		"leafType": "pine",
		"barkTint": 13552830,
		"barkTextureScaleX": 0.5,
		"barkTextureScaleY": 5,
		"forceStrength": 0,
		"targetHeight": 4.87 * 0.3,
	},
	footprintRadiusRatio: 1.136,
});
